export default __webpack_public_path__ + "static/media/english-to-italian-screenshot-06.37f837ba.png";